
function getPercentage(value: number, total: number, decimals = 2) {
    return ((value * 100) / total).toFixed(decimals);
}

export { getPercentage };